






















































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import http from "@/axios/http-common";
import DataRiwayat from "@/services/DataRiwayat";
import CardHasilBankDarah from "@/components/pemeriksaan/tabs/penunjang/CardHasilBankDarah.vue";

interface RegisterRow {
  register: string | number;
  masuk: string;
  unit?: { id: string; nama: string };
}

@Component({ components: { CardHasilBankDarah } })
export default class HasilBankDarahPage extends Vue {
  pasienItems: any[] = [];

  pasienLoading = false;

  pasienSearch: string | null = null;

  selectedPasien: any = null;

  registerOptions: any[] = [];

  loadingRegister = false;

  selectedRegister: string | null = null;

  get selectedRm(): string {
    return this.selectedPasien && typeof this.selectedPasien === "object"
      ? this.selectedPasien.rm
      : "";
  }

  get pasienNama(): string {
    return this.selectedPasien && this.selectedPasien.nama
      ? this.selectedPasien.nama
      : "";
  }

  get pasienUsia(): string {
    return this.selectedPasien && this.selectedPasien.usia
      ? this.selectedPasien.usia
      : "";
  }

  mounted() {
    const q = this.$route.query;
    if (q.rm && q.register) {
      this.bukaRegister(String(q.rm), String(q.register), q.nama ? String(q.nama) : "");
    }
  }

  pasienItemText(item: any): string {
    return item && typeof item === "object" ? `${item.rm} — ${item.nama}` : "";
  }

  pasienFilter(item: any, queryText: string): boolean {
    const q = (queryText || "").toLowerCase();
    return (
      String(item.rm || "").toLowerCase().indexOf(q) > -1 ||
      String(item.nama || "").toLowerCase().indexOf(q) > -1
    );
  }

  async doPasienSearch() {
    if (!this.pasienSearch) {
      this.pasienItems = [];
      return;
    }

    this.pasienLoading = true;
    try {
      const res = await http.getDataParam("/pasien", {
        params: { term: this.pasienSearch }
      });
      this.pasienItems = res.data || [];
    } catch (e) {
      this.pasienItems = [];
    } finally {
      this.pasienLoading = false;
    }
  }

  onPasienSelect(v: any) {
    this.selectedRegister = null;
    this.registerOptions = [];

    if (!v || typeof v !== "object") {
      this.selectedPasien = null;
      return;
    }

    this.loadRegister();
  }

  async loadRegister() {
    if (!this.selectedRm) return;

    this.loadingRegister = true;
    try {
      const resp = await DataRiwayat.getDataRiwayatRm(this.selectedRm, "");
      const raw = resp && resp.data;
      const list: RegisterRow[] = Array.isArray(raw) ? raw : [];

      this.registerOptions = list.map((r: RegisterRow) => ({
        value: String(r.register),
        text: `${this.tanggal(r.masuk)} — ${(r.unit && r.unit.nama) || "-"} (No. ${r.register})`
      }));

      if (this.registerOptions.length) {
        this.selectedRegister = this.registerOptions[0].value;
      }
    } catch (e) {
      this.registerOptions = [];
    } finally {
      this.loadingRegister = false;
    }
  }

  async bukaRegister(rm: string, register: string, nama: string) {
    this.selectedPasien = { rm, nama, usia: "" };
    this.pasienItems = [this.selectedPasien];
    await this.loadRegister();

    if (!this.registerOptions.some(o => o.value === register)) {
      this.registerOptions.unshift({ value: register, text: `No. ${register}` });
    }
    this.selectedRegister = register;
  }

  tanggal(iso: string): string {
    if (!iso) return "-";
    const d = moment(iso);
    return d.isValid() ? d.format("DD/MM/YYYY") : iso;
  }
}
